import React, { Component } from 'react';
import { Grid , Typography} from "@material-ui/core";
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import MyPATStepper from "../../../../../components/common/MyPATStepper";
import MyPATStep, { MyPATStepSubHeading, MyPATStepTitle } from "../../../../../components/common/MyPATStep";
import { StepStatus } from "../../../../common/types/Stepper";
import  ProgressBar from './ProgressBar';
import { connect } from 'react-redux';
import { ContentEvaluation } from "../../../types/Constants";
import { contentRequestActions } from '../../../reducers/trackProgressReducers';
import { ContentRequest, Question, Subject } from "../../../types/ContentRequest";
import { dateService } from "../../../../common";
import { RouteComponentProps } from "react-router";
import moment from 'moment';
import { getFormatedDate } from '../../../helpers/createContentRequest';
//import  RequestStepperProcess  from './RequestStepperProcess';


interface RequestStepperProcessProps extends RouteComponentProps {
    totalCount:any,
    trackProgressData:any,
    testDetails:any,
    requestId:any, 
    accordianState:any, 
    contentRequestData:any, 
    progressBar :any,
    type:any,
    questionData:any,
    overallData:any,
    data:any,
    requestType:string,
    createdCount:any,
    overallDone:any,
    match: any,
    ownerTaskByRoleData: any,
    contentRequest: ContentRequest,
}
interface RequestStepperProcessState {
    statusCreated: string, 
    statusEvaluted: string, 
    statusLang: string, 
    statusModerated: string, 
    statusPublished: string,
    progressCountPublisher: number,
    progressCountModerator: number,
    progressCountEvaluator: number,
    progressCountLangEval: number,
    progressCountCreator: number,
    hideProgressModerator: boolean,
    hideProgressEval: boolean,
    hideProgressLang: boolean,
    activeType: string,
    data :any, 
    overallData: any, 
    totalCount: any,
    isDisabledModerator: boolean,
    isDisabledEvaluator: boolean,
    isDisabledLangEval: boolean,
  }

 

const marginLeft = '900px';
const notYetStarted = 'Not Yet Started';
const inProgress = 'In Progress';
const createdBy = 'Done';


class RequestStepperProcess extends Component<RequestStepperProcessProps, RequestStepperProcessState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isDisabledModerator : false,
            isDisabledEvaluator : false,
            isDisabledLangEval : false,
            statusCreated: StepStatus.PENDING,statusEvaluted: StepStatus.PENDING, statusLang: StepStatus.PENDING,
            statusModerated: StepStatus.PENDING,statusPublished: StepStatus.PENDING,progressCountPublisher: 0,
            progressCountModerator: 0,progressCountEvaluator: 0,progressCountLangEval: 0,progressCountCreator: 0,
            hideProgressModerator: false,hideProgressEval: false,hideProgressLang: false,
            activeType:'Question', data :{}, overallData : {}, totalCount : 0
        }
    }

    getProcessStatus = (completed:any, total: any) =>{
        let status: any;
        if (completed === total) {
            status = StepStatus.DONE;
        } else if (completed !== 0) {
            status = StepStatus.INPROGRESS;
        } else {
            status = StepStatus.PENDING;
        }
        return status;
    }

    componentDidUpdate = (preProp: any) =>{
        if(preProp.totalCount !== this.props.totalCount ){
            this.loadPropsData();
        }
    }

    componentDidMount = () => {
       this.loadPropsData();
    }      

    loadPropsData = () =>{

        const {totalCount, trackProgressData,requestType,testDetails,questionData} = this.props;
        let all = 0;

        if(requestType === 'question'){
            questionData.forEach((indexData: any) => {
                const { contentRequestItemsId } = indexData;
                const { count = 0 } = indexData;
                 all += count;
                
            })
        }

        if(requestType === 'test'){
            all = totalCount;
        }
        
        this.setState({totalCount: all});
        if( totalCount === 0 && all ) {
           
            this.setState({statusCreated: StepStatus.PENDING});
            this.setState({statusEvaluted: StepStatus.PENDING});
            this.setState({statusLang: StepStatus.PENDING});
            this.setState({statusModerated: StepStatus.PENDING});
            this.setState({statusPublished: StepStatus.PENDING});
        }
        else{
            if (requestType === 'question') {

                let totalCount = all;
                let tempCreate = 0, tempModerate = 0, tempLang = 0, tempEval = 0, tempPublish = 0;
                questionData.forEach((indexData: any) => {
                    const { contentRequestItemsId } = indexData;
                   
                    if (contentRequestItemsId) {
                        const { contentRequestItemsId: { contentRequestId = '', contents = [], overallStatus = {} }, count = 0 } = indexData;
                        for( let i=0; i<contents.length; i++) {
                            if( contents[i].status.creator.isJobCompleted) {
                                this.setState(prevstate => ({ progressCountCreator: prevstate.progressCountCreator + 1}));
                                tempCreate += 1;
                            }
                            if( contents[i].status.publisher.isJobCompleted) {
                                this.setState(prevstate => ({ progressCountPublisher: prevstate.progressCountPublisher + 1}));
                                tempPublish++;
                            }
                        }
                        
                        if( contents.length === 0 ) {
                            this.setState({statusCreated: StepStatus.PENDING});
                        }
                        else {
                            (tempCreate === totalCount)? this.setState({statusCreated: StepStatus.DONE}) :
                            this.setState({statusCreated: StepStatus.INPROGRESS}); 
                        }
                
                        if( overallStatus.evaluator.isRequired === false) {
                            this.setState({statusEvaluted: StepStatus.PENDING,
                                isDisabledEvaluator : true});
                            this.setState({hideProgressEval: true});
                        }
                        else {
                            
                            if(overallStatus.evaluator.isRequired)
                            for( let i=0; i<contents.length; i++) {
                                if( contents[i].status.evaluator.isJobCompleted) {
                                    this.setState(prevstate => ({ progressCountEvaluator: prevstate.progressCountEvaluator + 1}));
                                    tempEval++;
                                }
                            }
                            if( contents.length === 0 ) {
                                this.setState({statusEvaluted: StepStatus.PENDING});
                            }
                            else {
                               // (tempEval === totalCount)? this.setState({statusEvaluted: StepStatus.DONE}) :
                                // (tempEval === 0)?this.setState({statusCreated: StepStatus.PENDING}):this.setState({statusEvaluted: StepStatus.INPROGRESS}); 
                                this.setState({statusEvaluted:this.getProcessStatus(tempEval,totalCount)});
                            }
                        }
                
                
                        if( overallStatus.languageEvaluator.isRequired === false) {
                            this.setState({statusLang: StepStatus.PENDING,
                            isDisabledLangEval : true});
                            this.setState({hideProgressLang: true});
                        }
                        else {
                            for( let i=0; i<contents.length; i++) {
                                if( contents[i].status.languageEvaluator.isJobCompleted) {
                                    this.setState(prevstate => ({ progressCountLangEval: prevstate.progressCountLangEval + 1}));
                                    tempLang++;
                            }}
                            if( contents.length === 0 ) {
                                this.setState({statusLang: StepStatus.PENDING});
                            }
                            else {
                                // (tempLang === totalCount)? this.setState({statusLang: StepStatus.DONE}) :
                                // this.setState({statusLang: StepStatus.INPROGRESS}); 
                                this.setState({statusLang:this.getProcessStatus(tempLang,totalCount)});
                            }
                        }
                
                
                        if( overallStatus.moderator.isRequired === false) {
                            this.setState({statusModerated: StepStatus.PENDING,
                                isDisabledModerator : true});
                            this.setState({hideProgressModerator: true});
                        }
                        else {
                            for( let i=0; i<contents.length; i++) {
                                if( contents[i].status.moderator.isJobCompleted) {
                                    this.setState(prevstate => ({ progressCountModerator: prevstate.progressCountModerator + 1}));
                                    tempModerate++;
                                    }
                            }
                            if( contents.length === 0 ) {
                                this.setState({statusModerated: StepStatus.PENDING});
                            }
                            else {
                                // (tempModerate === totalCount)? this.setState({statusModerated: StepStatus.DONE}) :
                                // this.setState({statusModerated: StepStatus.INPROGRESS}); 
                                this.setState({statusModerated:this.getProcessStatus(tempModerate,totalCount)});
                            }
                        }
                        if( contents.length === 0 ) {
                            this.setState({statusPublished: StepStatus.PENDING});
                        }
                        else {
                            // (tempPublish === totalCount)? this.setState({statusPublished: StepStatus.DONE}) :
                            // this.setState({statusPublished: StepStatus.INPROGRESS}); 
                            this.setState({statusPublished:this.getProcessStatus(tempPublish,totalCount)});
                        }
                
                
                    }
                })
            }

            if (requestType === 'test' && testDetails.contentRequestItemsId) {

                const { contentRequestItemsId: { contents = [], overallStatus = {} } = {} } = testDetails;
                let totalCount = all;
                let tempCreate = 0, tempModerate = 0, tempLang = 0, tempEval = 0, tempPublish = 0;

                for (let i = 0; i < contents.length; i++) {
                    if (contents[i].status.creator.isJobCompleted) {
                        this.setState(prevstate => ({ progressCountCreator: prevstate.progressCountCreator + 1 }));
                        tempCreate++;
                    }
                    if (contents[i].status.publisher.isJobCompleted) {
                        this.setState(prevstate => ({ progressCountPublisher: prevstate.progressCountPublisher + 1 }));
                        tempPublish++;
                    }
                }

                // setActiveCreated;
                if (contents.length === 0) {
                    this.setState({ statusCreated: StepStatus.PENDING });
                }
                else {
                    (tempCreate === totalCount) ? this.setState({ statusCreated: StepStatus.DONE }) :
                        this.setState({ statusCreated: StepStatus.INPROGRESS });
                }

                if (overallStatus.evaluator.isRequired === false) {
                    this.setState({ statusEvaluted: StepStatus.PENDING });
                    this.setState({ hideProgressEval: true });
                }
                else {
                    for (let i = 0; i < contents.length; i++) {
                        if (contents[i].status.evaluator.isJobCompleted) {
                            this.setState(prevstate => ({ progressCountEvaluator: prevstate.progressCountEvaluator + 1 }));
                            tempEval++;
                        }
                    }
                    if (contents.length === 0) {
                        this.setState({ statusEvaluted: StepStatus.PENDING });
                    }
                    else {
                        // (tempEval === totalCount) ? this.setState({ statusEvaluted: StepStatus.DONE }) :
                        //     this.setState({ statusEvaluted: StepStatus.INPROGRESS });
                        this.setState({statusEvaluted:this.getProcessStatus(tempEval,totalCount)});
                    }
                }


                if (overallStatus.languageEvaluator.isRequired === false) {
                    this.setState({ statusLang: StepStatus.PENDING });
                    this.setState({ hideProgressLang: true });
                }
                else {
                    for (let i = 0; i < contents.length; i++) {
                        if (contents[i].status.languageEvaluator.isJobCompleted) {
                            this.setState(prevstate => ({ progressCountLangEval: prevstate.progressCountLangEval + 1 }));
                            tempLang++;
                        }
                    }
                    if (contents.length === 0) {
                        this.setState({ statusLang: StepStatus.PENDING });
                    }
                    else {
                        // (tempLang === totalCount) ? this.setState({ statusLang: StepStatus.DONE }) :
                        //     this.setState({ statusLang: StepStatus.INPROGRESS });
                        this.setState({statusLang:this.getProcessStatus(tempLang,totalCount)});
                    }
                }


                if (overallStatus.moderator.isRequired === false) {
                    this.setState({ statusModerated: StepStatus.PENDING });
                    this.setState({ hideProgressModerator: true });
                }
                else {
                    for (let i = 0; i < contents.length; i++) {
                        if (contents[i].status.moderator.isJobCompleted) {
                            this.setState(prevstate => ({ progressCountModerator: prevstate.progressCountModerator + 1 }));
                            tempModerate++;
                        }
                    }
                    if (contents.length === 0) {
                        this.setState({ statusModerated: StepStatus.PENDING });
                    }
                    else {
                        // (tempModerate === totalCount) ? this.setState({ statusModerated: StepStatus.DONE }) :
                        //     this.setState({ statusModerated: StepStatus.INPROGRESS });
                        this.setState({statusModerated:this.getProcessStatus(tempModerate,totalCount)});
                    }
                }
                if (contents.length === 0) {
                    this.setState({ statusPublished: StepStatus.PENDING });
                }
                else {
                    // (tempPublish === totalCount) ? this.setState({ statusPublished: StepStatus.DONE }) :
                    //     this.setState({ statusPublished: StepStatus.INPROGRESS });
                    this.setState({statusPublished:this.getProcessStatus(tempPublish,totalCount)});
                }



            }
        }
    }
    
    percentageConvert = (totalCount: number, count: number) => {
        return Math.round(count*100/totalCount)
    }
    setActiveTab(event: any) {
        this.setState({
          activeType: event.target.id
        })
    }


    getUpdatedAtTime = (roleToCheck: string) => {
        const { ownerTaskByRoleData,requestType,contentRequestData } = this.props;
        let updatedAt = '';
        let subjectsData = !_.isEmpty(contentRequestData) && _.get(contentRequestData.requestInfo, 'details.subjects', []);
        let testData = !_.isEmpty(contentRequestData) && _.get(contentRequestData.requestInfo, 'details.testDetails', {});
        return  requestType === 'question' ? this.checkQuestionsData(subjectsData, roleToCheck) :this.checkTestData(testData, roleToCheck);
      
      }
    
      checkLoggedInUserRole = () => {
        return this.props.match.params.role
      }
    
      setAuthoredBy = (role: string) => {
       // return `By you . ${dateService.timeDate(this.getUpdatedAtTime(role))}`;
       return <>By you <span>&bull;</span> {getFormatedDate(this.getUpdatedAtTime(role))}</>;
      }
    
    
    getMostRecentUpdatedAt = (dateValues:string[]) => {
        const updatedDateValues = dateValues.map((dateValue) => new Date(dateValue));
        let mostRecent = updatedDateValues[0];
        console.log(updatedDateValues)
        console.log(mostRecent)
        updatedDateValues.forEach((dateValue) => {
          if(dateValue > mostRecent){
            mostRecent = dateValue
          }
        })
        
        return mostRecent;
    }
    
    
    
    checkQuestionsData = (data:Subject[], roleToCheck: string) => {
       
        const updatedAtValues:string[] = []
        console.log(data);
        console.log(roleToCheck);
        data && data.forEach((subject:Subject) => {
          subject.questions.forEach((question: Question) => {
            console.log(question);
            const updatedAt = _.get(question, `contentRequestItemsId.overallStatus.${roleToCheck}.updatedAt`, '')
            if(updatedAt) {
              updatedAtValues.push(updatedAt);
            }
          })
        })
        console.log(updatedAtValues);
    
        const mostRecentUpdatedAt = this.getMostRecentUpdatedAt(updatedAtValues);
        return mostRecentUpdatedAt;
      }

    checkTestData = (data: any, roleToCheck: string) => {

        const updatedAtValues:string[] = []
       const updatedAt = _.get(data, `contentRequestItemsId.overallStatus.${roleToCheck}.updatedAt`, '')
           
            if(updatedAt) {
              updatedAtValues.push(updatedAt);
            }
        
        const mostRecentUpdatedAt = this.getMostRecentUpdatedAt(updatedAtValues);
        return mostRecentUpdatedAt;
    }

    trackProcessStapper = () =>{
        const { 
             statusEvaluted, statusLang, statusModerated, statusPublished,progressCountPublisher,
            progressCountModerator,progressCountEvaluator,progressCountLangEval,progressCountCreator,hideProgressEval,
            hideProgressLang,hideProgressModerator
        } = this.state;

        const {totalCount} =this.state;
        const { trackProgressData, overallDone } =this.props;
        const createdCount = this.props.createdCount;
        let statusCreated = StepStatus.PENDING;
       
        if( createdCount === 0 ) {
            
            statusCreated = StepStatus.PENDING;
        }
        else if(this.checkLoggedInUserRole() === 'creator'){
            statusCreated = (createdCount === totalCount && overallDone)? StepStatus.DONE :StepStatus.INPROGRESS; 
        }else{
            statusCreated = (createdCount === totalCount)? StepStatus.DONE :StepStatus.INPROGRESS; 
        }

        const percentageCreated = this.percentageConvert(totalCount,createdCount );
        const percentageEvaluted = this.percentageConvert(totalCount, progressCountEvaluator);
        const percentageModerate = this.percentageConvert(totalCount, progressCountModerator);
        const percentageLangEval = this.percentageConvert(totalCount, progressCountLangEval);
        const percentagePublished =  this.percentageConvert(totalCount, progressCountPublisher);
       
        
        return (
            <>
            <Grid style={{marginTop: '15px'}}>
              <MyPATStepper >
                <MyPATStep status={statusCreated}>
                    <Grid container justify="space-between" alignItems="center">
                        <Grid item>
                            <MyPATStepTitle>CREATED</MyPATStepTitle>
                            {/* <Grid item xs={12} > */}
                        <MyPATStepSubHeading>
                        {!createdCount? notYetStarted : (createdCount !== totalCount ? inProgress: this.checkLoggedInUserRole() === 'creator' ? this.setAuthoredBy('creator'):'')}
                        </MyPATStepSubHeading>
                        {/* </Grid> */}
                        </Grid>
                       { totalCount ? <>
                            <Grid item>
                                <div>
                                <ProgressBar percentage={percentageCreated}  totalCount={totalCount} count={createdCount} />
                                </div>
                            </Grid>
                            </>:<></> 
                        }
                    </Grid>
                </MyPATStep>
                <MyPATStep  status={statusEvaluted}>
                <Grid container justify="space-between" alignItems="center">
                        <Grid item>
                            <MyPATStepTitle isDisabled={this.state.isDisabledEvaluator} >EVALUATED</MyPATStepTitle>
                            <Grid item>
                        {!hideProgressEval &&<MyPATStepSubHeading>
                            {!progressCountEvaluator? notYetStarted : (progressCountEvaluator !== totalCount ? inProgress: this.checkLoggedInUserRole() === 'evaluator' ? this.setAuthoredBy('evaluator'):'')}
                            </MyPATStepSubHeading>}
                        </Grid>
                        </Grid>
                       { totalCount ? <><Grid item>
                           <div>
                            {!hideProgressEval && <ProgressBar percentage={percentageEvaluted}  totalCount={totalCount} count={progressCountEvaluator}/>}
                            </div>
                        </Grid>
                       </>: <> </> }
                    </Grid>
                </MyPATStep>
                <MyPATStep status={statusLang}>
                <Grid container justify="space-between" alignItems="center">
                        <Grid item>
                            <MyPATStepTitle isDisabled={this.state.isDisabledEvaluator } >LANG. EVALUATED</MyPATStepTitle>

                            <Grid item>
                        {!hideProgressLang &&<MyPATStepSubHeading>
                            {!progressCountLangEval? notYetStarted : (progressCountLangEval !== totalCount ? inProgress:  this.checkLoggedInUserRole() === 'languageEvaluator' ? this.setAuthoredBy('languageEvaluator'):'')}
                            </MyPATStepSubHeading>}
                        </Grid>
                        </Grid>
                        {totalCount ? <><Grid item>
                            <div>
                            {!hideProgressLang && <ProgressBar percentage={percentageLangEval}  totalCount={totalCount} count={progressCountLangEval}/>}
                            </div>
                        </Grid>
                       </> : <></>}
                    </Grid>
                </MyPATStep>
                <MyPATStep status={statusModerated}>
                <Grid container justify="space-between" alignItems="center">
                        <Grid item>
                            <MyPATStepTitle isDisabled={ this.state.isDisabledEvaluator } >MODERATED</MyPATStepTitle>

                            <Grid item>
                        {!hideProgressModerator &&<MyPATStepSubHeading>
                            {!progressCountModerator? notYetStarted : (progressCountModerator !== totalCount ? inProgress: this.checkLoggedInUserRole() === 'moderator' ? this.setAuthoredBy('moderator'):'')}
                            </MyPATStepSubHeading>}
                        </Grid>
                        </Grid>
                        {totalCount ? <> <Grid item>
                            <div>
                            {!hideProgressModerator && <ProgressBar percentage={percentageModerate}  totalCount={totalCount} count={progressCountModerator}/>}
                            </div>
                        </Grid>
                       </> : <></>}
                    </Grid>
                </MyPATStep>
                <MyPATStep status={statusPublished}>
                <Grid container justify="space-between" alignItems="center">
                        <Grid item>
                            <MyPATStepTitle>PUBLISHED</MyPATStepTitle>
                            <Grid item>
                            <MyPATStepSubHeading>
                                {!progressCountPublisher? notYetStarted : (progressCountPublisher !== totalCount ? inProgress: this.checkLoggedInUserRole() === 'publisher' ? this.setAuthoredBy('publisher'):'')}
                            </MyPATStepSubHeading>
                        </Grid>
                        </Grid>
                        {totalCount ? <> 
                        <Grid item>
                            <div>
                            <ProgressBar percentage={percentagePublished} totalCount={totalCount} count={progressCountPublisher}/>
                            </div>
                        </Grid>
                        </> : <></>}
                    </Grid>
                </MyPATStep>
            </MyPATStepper>   
            </Grid>
            </>
        )
    }

  
    render() {
        
        return (
            <>
             {this.trackProcessStapper()}
            </>
        )
    }
}

const mapStateToProps = (state: any) => ({
    accordianTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianTouched', []),
    accordianCreateTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianCreateTouched', []),
    accordianState: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianState', []),
   ownerTaskByRoleData:state.contentRequestReducer.contentRequestReducer.ownerTaskByRoleData,
   contentRequest: state.contentRequestReducer.contentRequestReducer.ownerTaskByRoleData ,
   contentRequestData: _.get(state, 'contentRequestData.contentRequestData'),

});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    countZero: contentRequestActions.countZero
}, dispatch);


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RequestStepperProcess);